import React from 'react'
import ApiKeyManagement from '@/components/organisms/ApiKeyManagement'
import ApiUsageAnalytics from '@/components/organisms/ApiUsageAnalytics/index'
import ResourcesTab from './ResourcesTab'

interface Resource {
  id: string
  title: string
  description: string
  type: string
  downloadUrl: string
}

interface PartnerPortalContentProps {
  activeTab: string
  resources: Resource[]
  className?: string
}

const PartnerPortalContent: React.FC<PartnerPortalContentProps> = ({ 
  activeTab, 
  resources, 
  className 
}) => {
  return (
    <div className={`space-y-6 ${className}`}>
      {activeTab === 'api-keys' && <ApiKeysTab />}
      {activeTab === 'analytics' && <AnalyticsTab />}
      {activeTab === 'resources' && <ResourcesTab resources={resources} />}
    </div>
  )
}

const ApiKeysTab = () => {
  return (
    <div className="space-y-6">
      <ApiKeyManagement />
    </div>
  )
}

const AnalyticsTab = () => {
  return (
    <div className="space-y-6">
      <ApiUsageAnalytics />
    </div>
  )
}

export default PartnerPortalContent 